export enum ActionEnvironment {
    None = "None",
    Local = "Local",
    Alpha = "Alpha",
    Preprod = "Preprod",
    Prod = "Prod"
}